module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"year":"Year {n}"},"de":{"year":"{n} Jahre"}}')
  delete Component.options._Ctor
}
